var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.953125H16C17.1 0.953125 18 1.83906 18 2.92188V16.7031C18 17.7859 17.1 18.6719 16 18.6719H2C0.9 18.6719 0 17.7859 0 16.7031V2.92188C0 1.83906 0.9 0.953125 2 0.953125ZM7.49999 14.1688L15.2015 6.58766L13.7985 5.16235L7.49999 11.3624L4.70151 8.60767L3.29848 10.033L7.49999 14.1688Z",
    fill: "#FF006E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.a665c95323a258ee95759623ddc1a27c.svg";
export { ForwardRef as ReactComponent };